import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Playfair_Display\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-display\",\"display\":\"swap\"}],\"variableName\":\"playfair\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"DM_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-body\",\"display\":\"swap\"}],\"variableName\":\"dmSans\"}");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AdBlockBanner"] */ "/app/src/components/ads/AdBlockBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DirectLinkTracker"] */ "/app/src/components/ads/DirectLinkTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/src/components/layout/Providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PushNotificationPrompt"] */ "/app/src/components/pwa/PushNotificationPrompt.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PWAInstaller"] */ "/app/src/components/pwa/PWAInstaller.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AdBlockProvider"] */ "/app/src/contexts/AdBlockContext.tsx");
